import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import { Container, Card, Table, Button, Badge } from "react-bootstrap";

const ApplicationHistoryPage = () => {
  const { id: userId } = useParams();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        };
        const res = await axios.get(
          `${BASE_URL}/api/status-history/application/${userId}`,
          { headers }
        );

        let data = res.data || [];

        // ✅ Move current user to top
        data.sort((a, b) => {
          if (a.userId === Number(userId)) return -1;
          if (b.userId === Number(userId)) return 1;
          return new Date(a.createdDate) - new Date(b.createdDate);
        });

        setRecords(data);
      } catch (err) {
        console.error("❌ Failed to fetch application history:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [BASE_URL, userId]);

  return (
    <Container className="form-wrapper my-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">Application History</h3>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          ⬅ Return
        </Button>
      </div>

      <Card>
        <Card.Body>
          {loading ? (
            <p className="text-center text-muted">Loading...</p>
          ) : records.length === 0 ? (
            <p className="text-muted fst-italic">
              No application records found.
            </p>
          ) : (
            <Table
              bordered
              hover
              responsive
              className="align-middle text-center"
              style={{ cursor: "pointer" }}
            >
              <thead className="table-light">
                <tr>
                  <th>User ID</th>
                  <th>Created Date</th>
                  <th>Hiring Date</th>
                  <th>Type (Emp Category)</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {records.map((r, idx) => (
                  <tr
                    key={idx}
                    onClick={() => navigate(`/userhome/${r.userId}`)}
                    className={`table-row-hover ${
                      Number(r.userId) === Number(userId)
                        ? "table-primary fw-bold"
                        : ""
                    }`}
                    style={{
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <td>
                      {r.userId}{" "}
                      {Number(r.userId) === Number(userId) && (
                        <Badge
                          bg="light"
                          text="dark"
                          className="border border-secondary fw-normal ms-2"
                          style={{
                            fontSize: "0.75rem",
                            padding: "0.3rem 0.5rem",
                            borderRadius: "6px",
                            backgroundColor: "#e9ecef",
                          }}
                        >
                          Current Account
                        </Badge>
                      )}
                    </td>
                    <td>
                      {r.createdDate
                        ? dayjs(r.createdDate).format("MM/DD/YYYY")
                        : "-"}
                    </td>
                    <td>
                      {r.hiringDate
                        ? dayjs(r.hiringDate).format("MM/DD/YYYY")
                        : "-"}
                    </td>
                    <td>{r.empCategory || "-"}</td>
                    <td>{r.status || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      {/* Inline CSS for hover effect */}
      <style>{`
        .table-row-hover:hover {
          background-color: #f6f6f6 !important;
        }
      `}</style>
    </Container>
  );
};

export default ApplicationHistoryPage;
